import React from 'react';
import img1 from '../assets/Images/2-1.png';
import img2 from '../assets/Images/2-2.png';
import img3 from '../assets/Images/2-3.png';
import img4 from '../assets/Images/2-4.png';
import img5 from '../assets/Images/2-5.png';
import img6 from '../assets/Images/2-6.png';


const Regras = () => {
    let link1 = 'https://wa.me/+5521999462091';
    let link2 = 'https://wa.me/+5521999462091';
    let link3 = 'https://wa.me/+5521999462091';
    let link4 = 'https://wa.me/+5521999462091';
    let link5 = 'https://wa.me/+5521999462091';
    let link6 = 'https://wa.me/+5521999462091';


    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <a href={link1} style={{marginBottom: '2rem'}}>
                <img src={img1} alt="." style={{width: '70%', height: 'auto'}}/>
            </a>
            <a href={link2} style={{marginBottom: '2rem'}}>
                <img src={img2} alt="." style={{width: '70%', height: 'auto'}}/>
            </a>
            <a href={link3} style={{marginBottom: '2rem'}}>
                <img src={img3} alt="." style={{width: '70%', height: 'auto'}}/>
            </a>
            <a href={link4} style={{marginBottom: '2rem'}}>
                <img src={img4} alt="." style={{width: '70%', height: 'auto'}}/>
            </a>
            <a href={link5} style={{marginBottom: '2rem'}}>
                <img src={img5} alt="." style={{width: '70%', height: 'auto'}}/>
            </a>
            <a href={link6} style={{marginBottom: '2rem'}}>
                <img src={img6} alt="." style={{width: '70%', height: 'auto'}}/>
            </a>
        </div>

    );
};

export default Regras;
